import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-2"
}

import { computed } from 'vue';
import { useLoaderStore } from '@/store/loader';

export default /*@__PURE__*/_defineComponent({
  __name: 'LoaderGlobal',
  setup(__props) {

const loaderStore = useLoaderStore();
const loading = computed(() => loaderStore.loading);
const message = computed(() => loaderStore.message);

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!

  return (_openBlock(), _createBlock(_component_v_fade_transition, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_snackbar, {
        modelValue: loading.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary",
            size: "20",
            class: "mr-4"
          }),
          (message.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(message.value), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})